import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.Dropdown = class Dropdown extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-dropdown';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
	}
};



// WEBPACK FOOTER //
// ./components/dropdown/scripts/dropdown.js